import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';


@Component({
  selector: 'app-toolbar-item',
  templateUrl: './toolbar-item.component.html',
  styleUrls: ['./toolbar-item.component.scss']
})
export class ToolbarItemComponent implements OnInit{

  @Input() item!: IToolbarItem;
  @Input() selected: boolean = false;
  @Output() selectedChange = new EventEmitter<boolean>();
  
  public isActive: boolean = false;
  
  constructor(public router: Router) {  }

  ngOnInit() {
    if (this.item && this.item.route) {
      this.isActive = this.router.url.includes(this.item.route);
    }
  }
  toggleActive() {
    this.selected = !this.selected;
    this.selectedChange.emit(this.selected);
  }
}
